import React from 'react'
import { Link } from 'react-router-dom'

const UnauthorizedUser = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                <div className="text-center">
                    <h1 className="display-4 text-danger">403</h1>
                    <h2 className="mb-4">Unauthorized Access</h2>
                    <p className="text-muted">
                        You don't have permission to view this page. Please contact the administrator or navigate back.
                    </p>
                    <div className="mt-4">
                        <Link to="/" className="btn btn-primary me-2">
                            Go Home
                        </Link>
                        <button onClick={() => window.history.back()} className="btn btn-secondary">
                            Go Back
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnauthorizedUser